// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as TutorialComponent} from './Tutorial.svg';

import Icon, { TIconProps } from '../Icon';

export const IconTutorial = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <TutorialComponent/>
  </Icon>
));
